import {
  DASHBOARD_REQUEST,
  DASHBOARD_SUCCESS,
  DASHBOARD_FAIL,
} from "../actionTypes";

import axiosInstance from "../../api/axiosInstance";

// export const fetchDashboardData = (token) => async (dispatch) => {
//   try {
//     dispatch({ type: DASHBOARD_REQUEST });

//     const response = await axiosInstance.post("/api/dashboard/", {
//       access_token: token,
//     });
//     console.log("Dashboard response:", response.data); // Check if the data is correct

//     dispatch({ type: DASHBOARD_SUCCESS, payload: response.data });
//     console.log("Dashboard data fetched successfully:........", response.data);
//   } catch (error) {
//     dispatch({
//       type: DASHBOARD_FAIL,
//       payload: error.response ? error.response.data : error.message,
//     });
//   }
// };
export const fetchDashboardData = (token) => async (dispatch) => {
  try {
    dispatch({ type: DASHBOARD_REQUEST });

    const response = await axiosInstance.post("/api/dashboard/", {
      access_token: token,
    });
    console.log("Dashboard response:", response.data); // Check if the data is correct

    dispatch({ type: DASHBOARD_SUCCESS, payload: response.data.data }); // Store only `data` in Redux
  } catch (error) {
    dispatch({
      type: DASHBOARD_FAIL,
      payload: error.response ? error.response.data : error.message,
    });
  }
};

// export const getStatecityStatics = (token) => async (dispatch) => {
